import React from 'react';
import { ComponentFields } from '@sitecore-jss/sitecore-jss/types/layout/models';
import { Field, Image, LinkField, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps, resolveBackgroundStyle } from '@gn-audio/jss-components';
import { SitecoreImage } from '@gn-audio/jss-core';

import { useSpotTracking } from 'utils/hooks/useSpotTracking';

export interface LogoSpotItem {
  link: LinkField;
  linkAriaLabel?: Field<string>;
  logo: SitecoreImage;
  id: string;
  firstLinkTrackingName?: Field<string>;
}

export interface LogoSpot extends ComponentFields {
  [key: string]: any;
  logos: LogoSpotItem[];
  background: Field<string>;
  trackingSpotName?: Field<string>;
}

type LogoSpotProps = ComponentProps & {
  fields: LogoSpot;
};

const LogoSpot: React.FC<LogoSpotProps> = ({ fields }) => {
  const background = fields.background;
  const spotBackgroundStyle = resolveBackgroundStyle(background?.value as string);
  const spotRef = useSpotTracking(fields.trackingSpotName?.value);

  return (
    <div ref={spotRef} data-wt-spot={fields.trackingSpotName?.value} style={spotBackgroundStyle}>
      <ul className="container flex flex-wrap justify-center">
        {fields?.logos?.map(({ logo, link, id, firstLinkTrackingName, linkAriaLabel }) => {
          const LogoImage = <Image field={logo} loading="lazy" />;
          return (
            <li key={id}>
              {logo?.value &&
                (link?.value?.href ? (
                  <a
                    href={link.value.href}
                    className="block"
                    target="_blank"
                    rel="noreferrer"
                    {...(linkAriaLabel?.value && { 'aria-label': linkAriaLabel.value })}
                    {...(firstLinkTrackingName?.value && {
                      'data-wt-name': firstLinkTrackingName.value,
                    })}
                  >
                    {LogoImage}
                  </a>
                ) : (
                  LogoImage
                ))}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default withDatasourceCheck()(LogoSpot);
